// Атрибуты карточной практики. Бэкенд опознаёт практику по тройке
// practiceType/practiceFormat/learningMethod, поэтому значения обязаны совпадать
// у инициализации практики, её прохождения и запроса прогресса по карточкам —
// иначе поиск практики не найдёт ничего и прогресс молча обнулится.
export const CARD_PRACTICE_TYPE = 'FLASHCARD';
export const CARD_PRACTICE_FORMAT = 'SELF_ASSESSMENT';
export const CARD_LEARNING_METHOD = 'FIXED_SCHEDULE';
